.header {
  z-index: var(--z-header);
  position: sticky;
  top: 0;
  width: 100%;
  max-width: 100dvw;
  max-height: var(--header-height);
  background-color: var(--bloom-colors-header-main);
  padding-top: 16px;
  padding-right: 8px; /* right-padding is hard-coded to account for visual whitespace of icons */
  padding-bottom: 16px;
  padding-left: var(--page-margin);
}

.headerContent {
  display: grid;
  grid-template-areas: "logo icons";
  grid-template-columns: minmax(1px, max-content) 1fr;
  gap: 16px;
  margin: 0 auto;
  max-width: var(--page-max-width);
}

.storeLogoLink {
  grid-area: logo;
  cursor: pointer;
  height: 48px;
  max-width: 150px;
}

.storeLogo {
  max-height: 100%;
  width: 150px;
  object-fit: contain;
  object-position: left;
}

.icons {
  grid-area: icons;
  display: flex;
  flex-direction: row;
  margin-left: auto;
}

.searchIcon {
  color: var(--bloom-colors-header-contrast);
}

.searchField {
  display: none;
}

.searchField input:placeholder-shown {
  text-overflow: ellipsis;
}

.storeSwitcher--mobile {
  background-color: var(--bloom-colors-header-main);
  padding: 0 var(--page-margin) 16px;
}

.storeSwitcher--desktop {
  display: none;
  margin-right: auto;
}

@media all and (--reefer-media-tablet-min) {
  .header {
    padding-left: var(--page-margin-desktop);
    padding-right: var(--page-margin-desktop);
  }

  .headerContent {
    grid-template-areas: "logo switcher icons";
    grid-template-columns: auto minmax(215px, max-content) 1fr;
  }

  .header--borderless {
    border-bottom: none;
  }

  .storeSwitcher--desktop {
    display: block;
    grid-area: switcher;
  }

  .storeSwitcher--mobile {
    display: none;
  }
}

/* Non-standard pattern - introducing "tablet" width (768-1076) to lay out header elements. */
@media all and (width > 1076px) {
  .header {
    padding-left: var(--page-margin-desktop);
    padding-right: var(--page-margin-desktop);
    border-bottom: 1px solid var(--colors-grays-light);
  }

  .headerContent {
    grid-template-areas:
      "logo switcher search icons";
    grid-template-columns:
      auto minmax(215px, 1fr) minmax(150px, max-content) max-content;
  }

  .storeLogo {
    width: auto;
    max-width: 150px;
  }

  .searchForm {
    justify-content: flex-end;

    --colors-primary-main: var(--bloom-colors-header-main);

    grid-area: search;
    margin-left: auto;
    position: relative;
  }

  .searchField {
    display: flex;
    justify-content: flex-end;
  }

  .searchIcon {
    display: none;
  }
}
